import {  doc, onSnapshot } from '@firebase/firestore'
import React, { useState, useEffect, useContext } from 'react'
import {  useParams } from 'react-router'
import { db } from '../Config/firebase'
import { ProductDiv } from './Products'
import '../Styles/Checkout.css'
import {  DatabaseUserContext, UserContext } from '../App'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';




const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const Checkout = () => {
    const { p_id } = useParams()
    const [productToBeOrderd, setProductToBeOrderd] = useState(null)
    const [user, setUser] = useContext(UserContext)
    const [databaseUser, setDatabaseUser] = useContext(DatabaseUserContext)
    const [error, setError] = useState(null)
    let productPrice = 0
    const [deliveryDetails, setDeliveryDetails] = useState({})


    useEffect(() => {        
        window.scroll({ top: 0, left: 0 })

    }, [productToBeOrderd])


    useEffect(() => {

        if (databaseUser) {
            setDeliveryDetails({
                name: databaseUser.name,
                email: databaseUser.email,
                address: databaseUser.address
            })
        }



    }, [databaseUser])

    useEffect(() => {

        const docRef = doc(db, 'products', p_id)
        onSnapshot(docRef, (snapshot) => {
            setProductToBeOrderd(snapshot.data())
        })


    }, [])

    if (productToBeOrderd) {
        productPrice = productToBeOrderd?.price - ((productToBeOrderd?.discount / 100) * productToBeOrderd?.price).toFixed()
    }

    const handleProceddToPay = (event) => {
        event.preventDefault()
        fetch('https://e-shop-backend-payment-api.herokuapp.com/create-checkout-session', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                productName: productToBeOrderd.name,
                grandTotal: productPrice,
                productId:p_id,
                userId:user.uid
            })
        }).then(res => {
            if(res.ok) return res.json()

            return res.json().then( json => Promise.reject(json) )
        }).then(({ url })=>{
            console.log(url);
            window.location.replace(url);
            
        }).catch(error =>{
            alert( error.error )
        })
   



}


return (
    <div className='checkout'>
        <h1 className='checkout__heading'>Order Details</h1>
        <div className="productsToBeOrderdContainer">
            <div className="productsToBeOrderd">
                {productToBeOrderd ? <ProductDiv id={p_id} {...productToBeOrderd} /> : <></>}
            </div>
            <div className="productsToBeOrderdSummary">
                <p className="productsToBeOrderdSummary__brand">
                    {productToBeOrderd?.brandName}
                </p>
                <p className="productsToBeOrderdSummary__name">
                    {productToBeOrderd?.name}
                </p>

                <p className="productsToBeOrderdSummary__price">
                    Total : <span> ₹  {productPrice} </span>
                </p>
                <p className="productsToBeOrderdSummary__deliverycharge">
                    {productPrice > 40 ? <> <del>₹ 40</del> <span>Free Delivery</span> </> : <> ₹ {productPrice += 40} {productPrice} </>}
                </p>
                <p className="productsToBeOrderdSummary__total">

                    <span> Grand Total : </span>


                    {productPrice > 40 ?
                        <strong> ₹ {productPrice} </strong> :

                        <strong>
                            {productPrice + 40}
                        </strong>}

                </p>
            </div>
        </div>

        {databaseUser ? <>
            <h1 className='confirmDetails'>Confirm Delivery Details</h1>
            <div className="cofirmDeliveryDetails">


                <div className="confirmEmail confirmInputDiv">
                    <span> Your Name : </span>  <TextField
                        id="outlined-multiline-flexible"
                        label="Name"
                        multiline
                        maxRows={4}
                        value={deliveryDetails?.name}
                        onChange={(e) => setDeliveryDetails({ ...deliveryDetails, name: e.target.value })}
                        required
                    />
                </div>

                <div className="confirmEmail confirmInputDiv">
                    <span> Your Email : </span>  <TextField
                        id="outlined-multiline-flexible"
                        label="Email"
                        multiline
                        maxRows={4}
                        value={deliveryDetails?.email}
                        onChange={(e) => setDeliveryDetails({ ...deliveryDetails, email: e.target.value })}
                        required
                        type='email'
                    />
                </div>

                <div className="confirmEmail confirmInputDiv">
                    <span> Deliver To : </span>
                    <TextField
                        id="outlined-multiline-flexible"
                        label="Address"
                        multiline
                        rows={4}

                        value={deliveryDetails?.address}
                        onChange={(e) => setDeliveryDetails({ ...deliveryDetails, address: e.target.value })}
                        required
                    />
                </div>





            </div>
            <div className="payment__section">
                <div className="payment__title">
                    <h2> Payment Method </h2>
                </div>
                <div className="payment__details">

                    <h2 className='payment__details__card' >
                        We accept Cards
                    </h2>

                    <form className='card__form' onSubmit={handleProceddToPay}>

                

                        <div className="payment__priceContainer">
                            <p> Order Total :
                                <span>₹ {productPrice}  </span>
                            </p>
                            <Button variant='contained' color='success' className='placeOrderButton' type='submit'>

                                Proceed To Pay

                            </Button>
                        </div>

                        {error && <Snackbar open={true} autoHideDuration={6000} >
                            <Alert severity="error" sx={{ width: '100%' }}>
                                {error}
                            </Alert>
                        </Snackbar>}

                    </form>
                </div>
            </div>
        </> : <>
            <h1 className=' confirmOrderWarning '>
                Your need to SignIn or Create an E-shop account to continue
            </h1>
            <Link to='/' style={{ textDecoration: 'none' }}>
                <Button variant='contained' className='backToHome' >
                    Back To Home
                </Button>
            </Link>
        </>
        }




        <div style={{ height: '100vh' }}></div>



    </div>
)
}

export default Checkout
